import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PipesModule } from '../../../pipes/pipes.module';
import { IconComponent } from '../../icon/icon.component';
import { OverlayToggleDirective } from '../../overlay/overlay-toggle.directive';
import { IconButtonComponent } from '../../icon-button/icon-button.component';
import type { DatePickerComponent } from '../date-picker/date-picker.component';

@Component({
  selector: 'td-wb-date-picker-toggle',
  templateUrl: 'date-picker-toggle.component.html',
  styleUrls: ['date-picker-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconButtonComponent, OverlayToggleDirective, IconComponent, PipesModule]
})
export class DatePickerToggleComponent  {
  @Input('for') calendar: DatePickerComponent;

  @Input()
  get disabled(): boolean {
    if (this._disabled === undefined && this.calendar !== undefined) {
      return this.calendar.disabled;
    }

    return this._disabled;
  }

  set disabled(value: boolean) {
    this._disabled = value;
  }

  private _disabled: boolean = false;
}
